import React from 'react'
import { motion } from 'framer-motion'
import { fadeIn } from '../../utils/motion'
import Tilt from 'react-tilt'
import { github } from '../../Assets'
import { FaEye } from 'react-icons/fa'
import { Link } from 'react-router-dom'
const ProjectCard = ({
  index,
  name,
  description,
  tags,
  image,
  source_code_link,
}) => {
  return (
    <Link to={'/project-id/id'}>
      <motion.div
        variants={fadeIn('up', 'spring', index * 0.5, 0.85)}
        className='mx-auto'
      >
        <Tilt
          options={{ max: 45, scale: 1, speed: 450 }}
          className='bg-white shadow-md dark:shadow-none dark:bg-tertiary p-5 rounded-2xl sm:w-[360px] w-full '
        >
          <div className='relative w-full h-[230px]'>
            <img
              src={image}
              alt='name'
              className='w-full h-full object-cover rounded-2xl shadow-md dark:shadow-none'
            />
            <div className='absolute inset-0 flex justify-end m-3 card-img_hover'>
              <div
                className='black-gradient w-10 h-10 rounded-full flex justify-center items-center cursor-pointer mr-2'
                onClick={() => window.open(source_code_link, '_blank')}
              >
                <img
                  src={github}
                  alt='git'
                  className='w-1/2 h-1/2 object-contain'
                />
              </div>
              {/* <div
                className='black-gradient w-10 h-10 rounded-full flex justify-center items-center cursor-pointer'
                onClick={() => window.open(source_code_link, '_blank')}
              >
                <FaEye className='w-1/2 h-1/2 object-contain' />
              </div> */}
            </div>
          </div>

          <div className='mt-5 '>
            <h3 className='dark:text-white text-primary font-bold text-[24px]'>
              {name}
            </h3>
            <p className='mt-2 dark:text-secondary text[14px] text-gray-500'>
              {' '}
              {description}{' '}
            </p>
          </div>
          <div className='mt-4 flex flex-wrap gap-2 '>
            {tags.map((tag, index) => (
              <p
                className={`${tag.color} text-[14px] font-medium`}
                key={tag.name}
              >
                #{tag.name}
              </p>
            ))}
          </div>
        </Tilt>
      </motion.div>
    </Link>
  );
}

export default ProjectCard
